import React from 'react';

export function Forbidden() {
    return (
        <div className="container">
            <div className="jumbotron">
                <div className="row">
                    <div className="col-sm-1">
                        <i class="fa fa-minus-square fa-5x" aria-hidden="true" style={{ color: '#a94442' }} />
                    </div>
                    <div className="col-sm-11">
                        <dl className="dl-horizontal">
                            <dt className="text-uppercase">Error Code</dt>
                            <dd>HTTP 403 Forbidden</dd>

                            <dt className="text-uppercase">Error Description</dt>
                            <dd>Access Denied. You do not have the permission to access this page</dd>
                        </dl>
                    </div>
                </div>
            </div>
        </div>
    );
}